export default __webpack_public_path__ + "static/media/QRcode.418ec9aa.png";